import bsTab from 'bootstrap/js/dist/tab';

export default {
  install: (app, options) => {
    const tabs = document.querySelectorAll('[role="tablist"] button');
    const tabTriggers = [];

    tabs.forEach(button => {
      tabTriggers.push(new bsTab(button));
    });

    const show = id => {
      tabTriggers.forEach((tabTrigger, index) => {
        if (tabTrigger._config.target === `#${id}`) {
          tabTrigger.show();

          // Add - Remove class on parent element
          const parentEl = document.querySelector('[role="tablist"]');
          // const parentEl = tabTrigger._parent;
          const classesToRemove = Array.from(parentEl.classList).filter(className => className.startsWith('active-'));
          classesToRemove.forEach(className => parentEl.classList.remove(className));
          parentEl.classList.add(`active-${index}`)
        }
      });
    }

    const tab = { show };
    app.config.globalProperties.$tab = tab;
    app.provide('$tab', tab);
  }
}